import { useMemo } from 'react'
import benefitsData from '../config/benefits'
import { H4, S05, Text } from '../../../../styles/typography'
import { BenefitsEl, ItemEl } from '../elements/benefits'
import PricingStore from '../stores/pricing-store'

const Benefits = () => {
  const { data = [] } = PricingStore.useContainer()

  const proModel = useMemo(
    () =>
      data.find(
        (model) =>
          model?.name === 'Maestro' &&
          model?.frequency === 'ANNUAL' &&
          model?.status === 'ACTIVE',
      ),
    [data],
  )

  return (
    <BenefitsEl>
      <H4>LivDemy Pro Benefits</H4>

      <div className='items'>
        {benefitsData.map(({ key, graphic, title, text }) => (
          <ItemEl key={key} graphic={graphic}>
            <div className='graphic' />
            <div className='content'>
              <Text className='title'>{title}</Text>
              <S05 className='text'>{text(proModel)}</S05>
            </div>
          </ItemEl>
        ))}
      </div>
    </BenefitsEl>
  )
}

export default Benefits
